import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { supabase } from "@/integrations/supabase/client";
import { useEffect, useState } from "react";
import { Skeleton } from "@/components/ui/skeleton";

interface PhotoViewerModalProps {
  photoPath: string;
  onClose: () => void;
}

export function PhotoViewerModal({ photoPath, onClose }: PhotoViewerModalProps) {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadImage = async () => {
      try {
        console.log("Loading image from path:", photoPath);
        
        // Bucket is private, need signed URL
        const { data, error } = await supabase.storage
          .from("assisted-submissions")
          .createSignedUrl(photoPath, 3600); // 1 hour
        
        if (error) {
          console.error("Supabase storage error:", error);
          throw error;
        }
        
        if (!data?.signedUrl) {
          console.error("No signed URL returned");
          throw new Error("Failed to get signed URL");
        }
        
        console.log("Signed URL created successfully:", data.signedUrl);
        setImageUrl(data.signedUrl);
      } catch (error) {
        console.error("Error loading image:", error);
        setImageUrl(null);
      } finally {
        setLoading(false);
      }
    };

    if (photoPath) {
      loadImage();
    } else {
      console.error("No photoPath provided");
      setLoading(false);
    }
  }, [photoPath]);

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Foto da Refeição</DialogTitle>
        </DialogHeader>
        <div className="relative w-full h-[70vh] flex items-center justify-center bg-muted rounded-lg overflow-hidden">
          {loading ? (
            <Skeleton className="w-full h-full" />
          ) : imageUrl ? (
            <img 
              src={imageUrl} 
              alt="Foto da refeição" 
              className="max-w-full max-h-full object-contain"
            />
          ) : (
            <p className="text-muted-foreground">Erro ao carregar imagem</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
